var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { classNames } from '@web/utility';
import React from 'react';
import { Link } from 'react-router-dom';
var submenuText = 'font-menu text-sm font-semibold leading-6';
export var MenuItem = function (_a) {
    var item = _a.item, parentKey = _a.parentKey, index = _a.index, onClose = _a.onClose;
    var _b = React.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var timeoutRef = React.useRef(null);
    var handleMouseEnter = function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsHovered(true);
    };
    var handleMouseLeave = function () {
        timeoutRef.current = setTimeout(function () {
            setIsHovered(false);
        }, 100);
    };
    React.useEffect(function () {
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    if (item.children && item.children.length > 0) {
        return (_jsxs("div", __assign({ className: "relative group", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [_jsxs("div", __assign({ className: classNames('flex items-center rounded-lg px-3 py-2 hover:bg-gray-50 cursor-pointer whitespace-nowrap', submenuText, item.current
                        ? 'bg-indigo-50 text-indigo-600'
                        : 'text-gray-500 hover:text-gray-700') }, { children: [_jsx("span", __assign({ className: "mr-4 w-3" }, { children: item.icon })), _jsx("span", __assign({ className: "flex-1" }, { children: item.name })), _jsx(ChevronRightIcon, { "aria-hidden": "true", className: classNames('h-4 w-4 flex-none ml-2', item.current ? 'text-indigo-500' : 'text-gray-400') })] })), isHovered && (_jsx("div", __assign({ className: "absolute left-full top-0 ml-2 z-20 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: item.children.map(function (childItem, childIndex) {
                        return childItem.url ? (_jsxs(Link, __assign({ to: childItem.url, className: classNames('block rounded-lg px-3 py-2 hover:bg-gray-50 whitespace-nowrap', submenuText, childItem.current
                                ? 'bg-indigo-50 text-indigo-600'
                                : 'text-gray-500 hover:text-gray-700'), onClick: function () { return onClose(); } }, { children: [_jsx("span", __assign({ className: "mr-2 w-3" }, { children: childItem.icon })), childItem.name] }), "PopoverPanel-nested-href-".concat(parentKey, "-").concat(index, "-").concat(childIndex))) : (_jsxs("button", __assign({ className: classNames('block rounded-lg px-3 py-2 hover:bg-gray-50 text-gray-900 w-full text-left whitespace-nowrap', submenuText), onClick: function () {
                                var _a;
                                (_a = childItem.onClick) === null || _a === void 0 ? void 0 : _a.call(childItem);
                                onClose();
                            } }, { children: [_jsx("span", __assign({ className: "mr-2 w-3" }, { children: childItem.icon })), childItem.name] }), "PopoverPanel-nested-button-".concat(parentKey, "-").concat(index, "-").concat(childIndex)));
                    }) })))] })));
    }
    return item.url ? (_jsxs(Link, __assign({ to: item.url, className: classNames('block rounded-lg px-3 py-2 hover:bg-gray-50 whitespace-nowrap', submenuText, item.current
            ? 'bg-indigo-50 text-indigo-600'
            : 'text-gray-500 hover:text-gray-700'), onClick: function () { return onClose(); } }, { children: [_jsx("span", __assign({ className: "mr-2 w-3" }, { children: item.icon })), item.name] }), "PopoverPanel-href-".concat(parentKey, "-").concat(index))) : (_jsxs("button", __assign({ className: classNames('block rounded-lg px-3 py-2 hover:bg-gray-50 text-gray-900 w-full text-left whitespace-nowrap', submenuText), onClick: function () {
            var _a;
            (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
            onClose();
        } }, { children: [_jsx("span", __assign({ className: "mr-2 w-3" }, { children: item.icon })), item.name] }), "PopoverPanel-button-".concat(parentKey, "-").concat(index)));
};
